import React from "react";
import { Card, Row, Col, Button } from "antd";
import { FaFolderOpen } from "react-icons/fa";
import { formatCPF, formatCNPJ } from "../../../../utils/format-cpfcnpj";
import "./styles.css";

const PastaInfo = ({ pasta, onEdit }) => {
  if (!pasta) return null;

  const safeValue = (value) => {
    if (value === null || value === undefined) return "-";
    const str = String(value).trim();
    return str === "" ? "-" : str;
  };

  const formatDocument = (doc) => {
    if (!doc) return "-";
    const onlyNumbers = String(doc).replace(/\D/g, "");
    if (!onlyNumbers) return "-";
    return onlyNumbers.length === 11
      ? formatCPF(onlyNumbers)
      : formatCNPJ(onlyNumbers);
  };

  const formatEmail = (email) => {
    const value = safeValue(email);
    if (value === "-") return value;
    return (
      <a href={`mailto:${email}`} className="pasta-info__value-link">
        {email}
      </a>
    );
  };

  return (
    <Card className="pasta-info__card">
      <div className="pasta-info__header">
        <div className="pasta-info__title">
          <FaFolderOpen className="pasta-info__icon" />
          <div>
            <h2 className="pasta-info__pasta-nome">{safeValue(pasta.pasta)}</h2>
            <p className="pasta-info__cooperado">
              {safeValue(pasta.cooperado)}
            </p>
          </div>
        </div>
        <Button type="primary" icon="edit" onClick={onEdit}>
          Editar Pasta
        </Button>
      </div>

      <div className="pasta-info__content">
        {/* Linha 1: identificadores principais */}
        <Row gutter={16}>
          <Col xs={24} sm={12} md={6}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">Pasta</span>
              <span className="pasta-info__value">
                {safeValue(pasta.pasta)}
              </span>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">Cooperado</span>
              <span className="pasta-info__value">
                {safeValue(pasta.cooperado)}
              </span>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">Cliente</span>
              <span className="pasta-info__value">
                {safeValue(pasta.singular)}
              </span>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">CPF/CNPJ</span>
              <span className="pasta-info__value">
                {formatDocument(pasta.cpf_cnpj)}
              </span>
            </div>
          </Col>
        </Row>

        {/* Linha 2: dados bancários e contato básico */}
        <Row gutter={16}>
          <Col xs={24} sm={12} md={6}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">Agência</span>
              <span className="pasta-info__value">
                {safeValue(pasta.agencia)}
              </span>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">Conta</span>
              <span className="pasta-info__value">
                {safeValue(pasta.conta)}
              </span>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">Telefone</span>
              <span className="pasta-info__value">
                {safeValue(pasta.telefone)}
              </span>
            </div>
          </Col>
          <Col xs={24} sm={12} md={6}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">E-mail</span>
              <span className="pasta-info__value">
                {formatEmail(pasta.email)}
              </span>
            </div>
          </Col>
        </Row>

        {/* Linha 3: endereço (full width em mobile, metade+ em desktop) */}
        <Row gutter={16}>
          <Col xs={24} sm={24} md={24}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">Endereço</span>
              <span className="pasta-info__value">
                {safeValue(pasta.endereco)}
              </span>
            </div>
          </Col>
        </Row>

        {/* Linha 4: vínculo com contratos TXT */}
        <Row gutter={16}>
          <Col xs={24} sm={12} md={6}>
            <div className="pasta-info__field">
              <span className="pasta-info__label">Contrato TXT</span>
              <span className="pasta-info__value">
                {pasta.contrato ? safeValue(pasta.contrato) : "-"}
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default PastaInfo;



// WEBPACK FOOTER //
// ./src/pages/Pasta/components/PastaInfo/index.jsx